export enum AlertContextDispatchActionType {
	SetAlertComponent,
	OpenAlert,
	CloseAlert,
	SetPreventClose,
	SetCustomCloseCallback,
	SetCustomClassName,
}
